import moment from 'moment';

export default {
  name: 'DocumentsListElement',
  props: {
    document: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      acceptContract: this.document.is_accepted,
      animationStyleProperty: '',
    };
  },
  computed: {
    timeToExpired() {
      return moment(this.document.expired_at).diff(moment(), 'days');
    },
  },
  methods: {
    async downloadFile(pdfName) {
      const params = {
        document: this.document.uuid,
      };
      this.isLoading = true;
      const response = await this.$store.dispatch('documents/downloadDocument', params);
      this.isLoading = false;
      if (response) {
        this.forceFileDownload(response, pdfName);
        this.$store.dispatch('documents/getList'); // refresh for get file download status
      } else {
        this.$message({
          title: 'Błąd pobierania',
          message: 'Niestety nie udało się pobrać dokumentu, spróbuj później',
          type: 'error',
        });
      }
    },
    forceFileDownload(response, pdfName) {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');

      link.href = window.URL.createObjectURL(blob);
      link.download = `${pdfName}.pdf`;
      link.click();
    },
    runAnimation(length) {
      setTimeout(() => {
        this.animationStyleProperty = `animation: bounce-in ${length}s;`;
        setTimeout(() => {
          this.animationStyleProperty = '';
        }, length * 1000);
      }, 500);
    },
    async handleAcceptContract() {
      if (!this.document.is_downloaded) {
        this.runAnimation(2.5);
        this.$message({
          message: 'Pobierz dokument przed potwierdzeniem',
          type: 'error',
        });
        return;
      }
      const params = {
        document: this.document.uuid,
      };
      this.isLoading = true;
      const response = await this.$store.dispatch('documents/acceptContract', params);
      if (response) {
        this.$message({
          title: 'Sukces',
          message: 'Zaakceptowano dokument.',
          type: 'success',
        });
        await this.$store.dispatch('documents/getList');
      } else {
        this.$message({
          title: 'Błąd',
          message: 'Wystąpił błąd podczas akceptacji, spróbuj później',
          type: 'error',
        });
      }
      this.isLoading = false;
    },
  },
};
